
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-for-summer",
      function () {
        return require("private-next-pages/storage-for-summer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-for-summer"])
      });
    }
  